import React from "react";

const AboutMe = props => {
    return (
        <section id="about-me" className="section-about-me">{props.children}</section>
    )
}

export default AboutMe;